import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosReq } from "@/lib/axios";
import { GeneratedPostType, SocialPostType } from "../../types";
import { queryClient } from "@/lib/react-query" 
import { toast } from "sonner";
import { ApprovalContext, ApprovalContextType } from "../context";
import { useContext } from "react";

export const useSchedulePost = (onSchedule: (id: number) => void, eventIndex: number) => {
  const request = async (postId: number) => {
    const response = await axiosReq.post('/api/approval/schedule_post/', { post_id: postId });
    return response.data
  }

  const { mutate: schedulePost } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      toast.success("Event Scheduled successfully")
      queryClient.invalidateQueries({ queryKey: ["schedule_posts"] })
      queryClient.invalidateQueries({ queryKey: ["socials-unreviewed"] })
      queryClient.invalidateQueries({ queryKey: ["timeline"] })
      onSchedule(eventIndex)
    }
  })

  return { schedulePost }
}

export const useRegenerateEvent = (setLoading: () => void) => {
  const request = async ({ id, prompt }: { id: number, prompt: string }): Promise<{
    message: string,
    post: {
      post_id: number,
      platform: string,
      text: string,
      image_video_recommendations: string,
      hashtags: string[],
      cta: string[],
      date_of_posting: string,
      time_of_posting: string,
    }[]
  }> => {
    const response = await axiosReq.post('/api/approval/regenerate_posts/', {
      event_id: id,
      recommendation: prompt
    })
    return response.data
  }


  const { mutate: regenerateEvent, status } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["socials-unreviewed"] })
      setLoading()
    }
  })

  return { regenerateEvent, status }
}

export const useGetCreatedEventImage = () => {

  const { setImageLoader } = useContext<ApprovalContextType>(ApprovalContext)

  const request = async (id: number): Promise<{
    status: string,
    data: {
      event_id: number,
      posts: GeneratedPostType[]
    }
  }> => {
    const response = await axiosReq.post('/api/approval/generate-images-event/', { event_id: id })
    return response.data
  }
  const { data: generatedDataWithImages, status, mutate: generateImage } = useMutation({
    mutationFn: (id: number) => request(id),
    onSuccess: (data) => {
      if (data) {
        setImageLoader(false)
      }
    }
  })
  return { generateImage, generatedDataWithImages, status }
}

export const useGetUnreviewedSocialPosts = (page: number, start_date: string, end_date: string) => {
  const request = async(): Promise<
    {
      message: string,
      data: SocialPostType[],
    }> => {
    const response = await axiosReq.post('/api/approval/get-lookback-posts/',
      {
        page: page,
        start_date: end_date,
        end_date: start_date
      });
    return response.data;
  }

  const { data: socialPosts, isLoading } = useQuery({
    queryKey: ["socials-unreviewed", start_date, end_date, page],
    queryFn: request
  });

  return { socialPosts, isLoading }
}

